export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1769_.032d4a2d.jpg";